export const redirectToAccount = (path?: string) => {
  const redirectURL = `${process.env.REACT_APP_ACCOUNT_URL}${path ?? ""}`;
  window.location.href = redirectURL;
};
